/** The slice both settings DTO shapes (project base settings and album settings) share — the strip
 *  needs nothing else, so both sides call in without casts. */
export interface DesignPackSettingsSlice {
  photoBook?: {
    design?: {
      designPackageId?: string | null;
    };
  };
}

// A structure overlay never touches the pack; dropping it is this explicit act — the cleaned settings
// persist with the generated book, so a once-poisoned album heals for good.
// `settings` may be a RE-READ snapshot taken after the conflict was computed (backend sync's
// saveSettingsOnly and the frontend's reset-regen path both deliberately reload live settings to honor
// concurrent edits) — by persist time it can legally already carry a DIFFERENT, compatible pack.
// Stripping unconditionally would silently wipe that just-applied pack, so the strip only fires when the
// snapshot still names the SAME conflicted pack id; a mismatch means someone else resolved the conflict
// already and is left alone.
export function withoutIncompatibleDesignPack<T extends DesignPackSettingsSlice>(settings: T, designPackageId: string): T {
  const design = settings.photoBook?.design;
  if (design?.designPackageId !== designPackageId) return settings;
  // The spread rebuilds the full concrete shape at runtime; only the static type narrows to the slice.
  return { ...settings, photoBook: { ...settings.photoBook, design: { ...design, designPackageId: null } } } as T;
}
